/* eslint-disable */
/**
* JQuery Google Analytics Event Tracker wrapper Plugin
* Gaet 1.1 - By Creuna (http://www.creuna.se)
*
* Gaet Copyright (c) 2011 Creuna.
* Licensed under the MIT License: http://www.opensource.org/licenses/mit-license.php
*/

(function ($) {
    function sendEvent(data) {
        window._mtm.push(data)
    };

    $('.modal').on('shown.bs.modal', function (e) {
        sendEvent({ event: 'Modal', category: 'Modal', action: 'Visat' })
    });

    //$.fn.trackOmAlectaSidhuvud = function () {
    //    // Rubrik
    //    $(this).on('click', '#slideshow-talespersoner .hero-lank-rubrik', function () {
    //        var rubrik = $(this).find('h2').text();
    //        $(this).trackLink('hero', 'rubrik', rubrik);
    //    });
    //    // Knapp
    //    $(this).on('click', '#slideshow-talespersoner .hero-lank-knapp', function (e) {
    //        $(this).trackLink('hero', 'knapp', e.target.href);
    //    });
    //    // Slide-knapp förra
    //    $(this).on('click', '#slideshow-talespersoner .slick-prev', function () {
    //        var slide = $('#slideshow-talespersoner .slick-slide.slick-current');
    //        var index = slide.data('slick-index');
    //        $(this).trackLink('hero', 'slide-knapp-forra', index++);
    //    });
    //    // Slide-knapp nästa
    //    $(this).on('click', '#slideshow-talespersoner .slick-next', function () {
    //        var slide = $('#slideshow-talespersoner .slick-slide.slick-current');
    //        var index = slide.data('slick-index');
    //        $(this).trackLink('hero', 'slide-knapp-nasta', index++);
    //    });
    //    // Talespersoner
    //    $(this).on('click', '#slideshow-talespersoner .slick-dots li', function () {
    //        $(this).trackLink('hero', 'talesperson', $(this).find('.namn').text());
    //    });
    //};

})(jQuery);
